import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { MatProgressSpinnerModule } from '@angular/material';
import { UserService, AuthenticationService } from '../_services';
import { MatSnackBar} from '@angular/material/snack-bar';

@Component({ 
  templateUrl: 'register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
    registerForm: FormGroup;
    loading = false;
    submitted = false;
    error: string;
    loginFormCorreo          : FormControl;
    loginFormPassword        : FormControl;
    loginFormEmpresa         : FormControl;
    loginFormTelefono        : FormControl;
    loginFormNombreUsuario   : FormControl;
    loginFormPasswordConfirm : FormControl;
    spinner                  = false;
    net_status               = 'online';

    //Amazon
    amazon_callback_uri: string;
    amazon_state: string;
    selling_partner_id: string;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private userService: UserService,
        private snackBar: MatSnackBar,
    ) {
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(['/']);
        }
    }

    ngOnInit() {
        
        setInterval(() => { 
          this.validar_conexion_internet(); 
        }, 3000);
      console.log(this.net_status);
        this.registerForm = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            username: ['', Validators.required],
            password: ['', [Validators.required, Validators.minLength(6)]]
        });

      this.loginFormCorreo = new FormControl('', [
        Validators.required,
        Validators.email,
      ]);

      this.loginFormPassword = new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(
          /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/
        ),
      ]);
      this.loginFormPasswordConfirm = new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(
          /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/
        ),
      ]);

      this.loginFormEmpresa = new FormControl('', [
        Validators.required
      ]);

      this.loginFormTelefono = new FormControl('', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(10)
      ]);

      this.loginFormNombreUsuario = new FormControl('', [
        Validators.required
      ]);

      //Get Amazon params
      this.amazon_callback_uri = this.route.snapshot.queryParams['amazon_callback_uri'];
      this.amazon_state = this.route.snapshot.queryParams['amazon_state'];
      this.selling_partner_id = this.route.snapshot.queryParams['selling_partner_id'];
    }
    validar_conexion_internet(){
      if(navigator.onLine) {
        this.net_status = 'online';
         
      } else {
        this.net_status = 'offline';
         
      }
    }
    // convenience getter for easy access to form fields
    get f() { return this.registerForm.controls; }

    onSubmit() {

      // stop here if form is invalid
      if (this.loginFormCorreo.invalid || this.loginFormPassword.invalid ||this.loginFormPasswordConfirm.invalid || this.loginFormEmpresa.invalid || this.loginFormTelefono.invalid || this.loginFormNombreUsuario.invalid||(this.loginFormPasswordConfirm.value !=this.loginFormPassword.value)){
        if(this.loginFormPasswordConfirm.value !=this.loginFormPassword.value){
          this.snackBar.open("Las contraseñas no coinciden", "alerta", {                      
            duration: 5000,
          });
        }
        return;
      }

      this.loading = true;
      this.spinner = true;
      this.userService.register(this.loginFormCorreo.value, this.loginFormEmpresa.value, this.loginFormPassword.value,this.loginFormTelefono.value,this.loginFormNombreUsuario.value)
      .pipe(first())
      .subscribe(
      data => {
        this.spinner = false;
        // console.log("La data es")
        // console.log(data)
        if(data.result == 200){
          this.snackBar.open(data["messages"], "OK", {                      
            duration: 5000,
          });
          setTimeout(() => {
            if ( (this.amazon_callback_uri != null) && (this.amazon_state != null) && (this.selling_partner_id != null)) {
              this.router.navigate(
                ['/login'],
                {queryParams: {
                  amazon_callback_uri: this.amazon_callback_uri,
                  amazon_state: this.amazon_state,
                  selling_partner_id: this.selling_partner_id
                }}
              );
            }else{
              window.location.href = data["messages"]
            }
          }, 2500);
          
        }else{
          let mensaje = data["messages"];
          if(data.result == 401){
            mensaje = "Ya existe una cuenta registrada con este correo"
          }
          this.loading = false;
          this.snackBar.open(mensaje, "OK", {                      
            duration: 5000,
          });
        }
        // this.router.navigate(['/login'], { queryParams: { registered: true }});
         

      },
      error => {
        
        this.error = error;
        this.loading = false;
        this.spinner = false;
        this.snackBar.open('Error de conexión, Intentelo mas tarde', ":(", {                      
          duration: 5000,
        });
         
      });
    }

    redirectRegistrar(){
      this.router.navigate(['/login']);
    }
}